export function generateUUID() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function getBase64Extension(base64 = "") {
  return base64.split(";")[0];
}

export async function base64ToFile(url = "") {
  return fetch(url)
    .then(res => res.blob())
    .then(blob => {
      return new File([blob], "Arquivo", { type: getBase64Extension(url) });
    });
}

export function orderedDates(dates = [], order = "asc") {
  const ordered = dates.sort(function (a, b) {
    return new Date(`${a}T00:01`) - new Date(`${b}T00:01`);
  });

  if (order == "desc") return ordered.reverse();

  return ordered;
}

export function orderedDate(dates = [], first = false, format = true) {
  const sortdate = dates.sort(function (a) {
    return new Date(`${a}T00:01`);
  });

  if (first && !format) return sortdate[0];

  if (format) {
    if (first)
      return new Date(`${sortdate[0]}T00:01`).toLocaleDateString("pt-BR");

    return sortdate.map(x =>
      new Date(`${x}T00:01`).toLocaleDateString("pt-BR")
    );
  }

  return sortdate;
}

